import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: '100%',
  },
  numberBox: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    borderRadius: '50%',
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  guideLink: {
    color: theme.palette.common.white,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.common.white,
      opacity: 0.85,
    },
  },
}))

export default useStyles
